import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

// const EM = [
//   "LFL",
//   "UL",
//   "PL",
//   "LVP SL",
//   "NLC",
//   "EBL",
//   "PGN",
//   "GLL",
//   "LPLOL",
//   "HM",
//   "ES",
// ];

function Navigation({ service, league, language }) {
  let navigate = useNavigate();
  const options = [

    {
      label: "Worlds",
      options: [
        {
          label: "WQS",
          value: "WQS",
        },
        {
          label: "Play-In",
          value: "PlayIn",
        },
        {
          label: "Main Event",
          value: "MainEvent",
        },
      ],
    },
    // {
    //   label: "Major",
    //   options: ["LCK", "LPL", "LEC", "LCS"].map((_league) => ({
    //     label: _league,
    //     value: _league,
    //   })),
    // },
    // {
    //   label: "Minor",
    //   options: ["PCS", "VCS", "CBLOL", "LJL", "LLA", "LCO"].map((_league) => ({
    //     label: _league,
    //     value: _league,
    //   })),
    // },
  ];

  return (
    <Select
      onChange={(event) => {
        navigate(`/${language}/${service}/${event.value}`);
      }}
      options={options}
    />
  );
}

Navigation.propTypes = {
  service: PropTypes.string.isRequired,
  league: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default Navigation;
